import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import b from 'b_';
import AuthenticationConfigurationStore
    from '../../stores/AuthenticationConfigurationSSO/AuthenticationConfigurationStore';
import AuthenticationConfEditStore from '../../stores/AuthenticationConfigurationSSO/AuthenticationConfEditStore';
import FuseConfirmationModal from '../ConfirmationModal/FuseConfirmationModal';
import { ConsoleCard, FuseConsoleField } from '../ConsoleFragments';
import FuseButton from '../FuseControls/FuseButton';
import FuseTextfield from '../FuseControls/FuseTextfield';
import Page from '../Fuse/Page';
import { FTBody, FTHeading } from '../Fuse/';
import EditConfigurationModal from './EditConfigurationModal';
import KeyCreateModal from './KeyCreateModal';
import KeyDeleteModal from './KeyDeleteModal';
import SnackStore from '../../stores/SnackStore';
import copyText from '../../copyText';
import ConsoleStore from '../../stores/ConsoleStore';
import ResetIDPModal from './ResetIDPModal';
import UDSpinner from '../UD/Fragments/UDSpinner';
import RegOptionsStore from '../../stores/RegOptionsStore';
import FuseAlert from '../FuseControls/FuseAlert';
import PolicyStore from '../../stores/Policy/PolicyStore';
import { REGISTRATION_TYPE } from '../../stores/Policy/BrowsingRoles/BrowserIsolationOptionsStore';
import { ROLE_READ_ONLY } from '../../stores/Administrators/AdministratorModalStore';
import './AuthenticationConfigurationPage.css';

const block = b.lock('AuthenticationConfigurationPage');

class AuthenticationConfigurationPage extends Component {
    static propTypes = {
        regOptions: RegOptionsStore.PropType.isRequired,
        policy: PolicyStore.PropType.isRequired,
        authenticationConfiguration: AuthenticationConfigurationStore.PropType.isRequired,
        snack: SnackStore.PropType.isRequired,
        console: ConsoleStore.PropType.isRequired,
    };

    state = {
        useSSOLogin: false
    }

    componentWillMount() {
        const { console, snack, authenticationConfiguration, regOptions, policy } = this.props;
        const { policyTable } = policy.browsingRoles;

        if (console.isSSOConfigured) {
            authenticationConfiguration.load()
                .catch((error) => snack.showError(`Failed to load sso configuration. ${error && error.message}`));

            if (console.useRedesignedPolicy) {
                policyTable.load()
                    .then(() => {
                        const useSSOLogin = policyTable.items
                            .some((role) => role.browserAuthenticationMethod === REGISTRATION_TYPE.SAML_SSO);
                        this.setState({ useSSOLogin });
                    })
                    .catch((error) => snack.showError(`Failed to load browsing-roles. ${error && error.message}`));
            }
        } else {
            authenticationConfiguration.setNotConfigured();
        }
        if (!console.useRedesignedPolicy) {
            regOptions.load()
                .then(() => this.setState({ useSSOLogin: regOptions.useSSOLogin }))
                .catch((error) => snack.showError(`Failed to load registration options. ${error && error.message}`));
        }
    }

    copyToClipboard = (text, itemName) => {
        if (copyText(text)) {
            this.props.snack.showSuccess(`${itemName} has been copied to clipboard`);
        } else {
            this.props.snack.showError('Unable to copy');
        }
    };

    renderLDAP() {
        const { authenticationConfiguration: authConfStore } = this.props;
        if (authConfStore.isLDAP) {
            return <Fragment>
                {authConfStore.ldapType ?
                    <FuseConsoleField
                        className={block('ConsoleField')}
                        name="LDAP Type"
                    >
                        {authConfStore.ldapType}
                    </FuseConsoleField> : null
                }
                <FuseConsoleField
                    className={block('ConsoleField')}
                    name="LDAP URL"
                >
                    {authConfStore.ldapURL}
                </FuseConsoleField>
                <FuseConsoleField
                    className={block('ConsoleField')}
                    name="Username"
                >
                    {authConfStore.userName}
                </FuseConsoleField>
                <FuseConsoleField
                    className={block('ConsoleField')}
                    name="Password"
                >
                    {'••••••••••'}
                </FuseConsoleField>
                <FuseConsoleField
                    className={block('ConsoleField')}
                    name="User Base DN"
                >
                    {authConfStore.userBaseDN}
                </FuseConsoleField>
                <FuseConsoleField
                    className={block('ConsoleField')}
                    name="Group Base DN"
                >
                    {authConfStore.groupsBaseDN ? authConfStore.groupsBaseDN : '--'}
                </FuseConsoleField>
                <FuseConsoleField
                    className={block('ConsoleField')}
                    name="User Filter"
                >
                    {authConfStore.usersFilter ? authConfStore.usersFilter : '--'}
                </FuseConsoleField>
                <FuseConsoleField
                    className={block('ConsoleField')}
                    name="Group Filter"
                >
                    {authConfStore.groupsFilter ? authConfStore.groupsFilter : '--'}
                </FuseConsoleField>
                <FuseConsoleField
                    className={block('ConsoleField')}
                    name="Certificate (PEM)"
                >
                    {authConfStore.LDAP_Certificate ? authConfStore.LDAP_Certificate : '--'}
                </FuseConsoleField>
            </Fragment>;
        }
        return null;
    }

    renderSCIM() {
        const { authenticationConfiguration: authConfStore } = this.props;
        if (authConfStore.isSCIM) {
            return <Fragment>
                {authConfStore.hasKey ?
                    <Fragment>
                        <FuseConsoleField
                            className={block('ConsoleField')}
                            name="SCIM API Key"
                        >
                            <span className={block('KeyField')}>{'••••••••••••••'}</span>
                        </FuseConsoleField>
                    </Fragment> : null
                }
                <div className={block('URLsField')}>
                    <FuseTextfield
                        store={authConfStore.tenantURL}
                        label="Base/Tenant URL"
                        className={block('URLsTextField')}
                        disabled
                    />
                    <FuseButton
                        type={'tertiary'}
                        color={'blue'}
                        icon={'assignment'}
                        className={block('UrlsButton')}
                        onClick={() => this.copyToClipboard(
                            authConfStore.tenantURL.value, 'Base/Tenant URL')}
                    > <FTBody className={block('UrlsButtonText')}>Copy to clipboard</FTBody> </FuseButton>
                </div>
            </Fragment>;
        }
        return null;
    }

    renderJIT = (authConfStore) => {
        if (authConfStore.isJIT || authConfStore.isSCIM) {
            return <Fragment>
                <FuseConsoleField
                    className={block('ConsoleField')}
                    name="Just In Time (JIT)"
                >
                    <FTBody>
                        {authConfStore.justInTime ? 'Enabled' : 'Disabled'}
                    </FTBody>
                </FuseConsoleField>
                <FuseConsoleField
                    className={block('ConsoleField')}
                    name="IdP Assume Ownership"
                >
                    <FTBody>
                        {authConfStore.idpAssumeOwnership ? 'Enabled' : 'Disabled'}
                    </FTBody>
                </FuseConsoleField>
            </Fragment>;
        }
        return null;
    };

    renderIdentityProvider = (authConfStore) => {
        return <div className={block('InnerSection')}>
            <FTHeading>Identity Provider</FTHeading>
            <FuseConsoleField
                className={block('ConsoleField')}
                name="Identity Provider SSO URL"
            >
                <span className={block('WrapText')}>{authConfStore.idProviderURL}</span>
            </FuseConsoleField>
            <FuseConsoleField
                className={block('ConsoleField')}
                name="Identity Provider Issuer"
            >
                <span className={block('WrapText')}>{authConfStore.idProviderIssuer}</span>
            </FuseConsoleField>
            <FuseConsoleField
                className={block('ConsoleField')}
                name="X.509 Certificate"
            >
                <span className={block('WrapText')}>{authConfStore.X_Certificate}</span>
            </FuseConsoleField>
            {authConfStore.contextClass ?
                <FuseConsoleField
                    className={block('ConsoleField')}
                    name="Authentication Context Class"
                >
                    {authConfStore.editStore.convertContextClassValueToDisplayName(authConfStore.contextClass)}
                </FuseConsoleField> : null
            }
        </div>;
    };

    getRenderAuthType = (authConfStore) => {
        if (authConfStore.authType === AuthenticationConfEditStore.AUTH_TYPE.IDP) {
            return <span><b>Configure an IdP</b>  - configure your own identity provider.</span>;
        }
        if (authConfStore.authType === AuthenticationConfEditStore.AUTH_TYPE.META) {
            return <span><b>Proofpoint Meta</b>  - use an existing Proofpoint Meta IdP configuration.</span>;
        }
        return null;
    };

    renderUrls(authConfStore) {
        return <div className={block('InnerSection')}>
            <FTHeading>SSO URLs</FTHeading>
            <div className={block('URLsField')}>
                <FuseTextfield
                    store={authConfStore.ssoURL}
                    label="SSO URL"
                    className={block('URLsTextField')}
                    disabled
                />
                <FuseButton
                    type={'tertiary'}
                    color={'blue'}
                    icon={'assignment'}
                    className={block('UrlsButton')}
                    onClick={() => this.copyToClipboard(authConfStore.ssoURL.value, 'SSO URL')}
                > <FTBody className={block('UrlsButtonText')}>Copy to clipboard</FTBody> </FuseButton>
            </div>
            <div className={block('URLsField')}>
                <FuseTextfield
                    store={authConfStore.recipientURL}
                    label="Recipient URL"
                    className={block('URLsTextField')}
                    disabled
                />
                <FuseButton
                    type={'tertiary'}
                    color={'blue'}
                    icon={'assignment'}
                    className={block('UrlsButton')}
                    onClick={() => this.copyToClipboard(
                        authConfStore.recipientURL.value, 'Recipient URL')}
                > <FTBody className={block('UrlsButtonText')}>Copy to clipboard</FTBody> </FuseButton>
            </div>
            <div className={block('URLsField')}>
                <FuseTextfield
                    store={authConfStore.destinationURL}
                    label="Destination URL"
                    className={block('URLsTextField')}
                    disabled
                />
                <FuseButton
                    type={'tertiary'}
                    color={'blue'}
                    icon={'assignment'}
                    className={block('UrlsButton')}
                    onClick={() => this.copyToClipboard(
                        authConfStore.destinationURL.value, 'Destination URL')}
                > <FTBody className={block('UrlsButtonText')}>Copy to clipboard</FTBody> </FuseButton>
            </div>
            <div className={block('URLsField')}>
                <FuseTextfield
                    store={authConfStore.audienceURL}
                    label="Audience URI (SP Entity ID)"
                    className={block('URLsTextField')}
                    disabled
                />
                <FuseButton
                    type={'tertiary'}
                    color={'blue'}
                    icon={'assignment'}
                    className={block('UrlsButton')}
                    onClick={() => this.copyToClipboard(
                        authConfStore.audienceURL.value, 'Audience URI')}
                > <FTBody className={block('UrlsButtonText')}>Copy to clipboard</FTBody> </FuseButton>
            </div>
        </div>;
    }

    renderContent = (authConfStore) => {
        if (authConfStore.hasSamlConnectionError) {
            return <Fragment>
                <FuseAlert
                    title={'SAML Connection Error'}
                    type="danger"
                    showArrowButton={false}
                    className={block('ConsoleField')}
                >
                    <FTBody>
                        A configuration object is missing in the Meta infrastructure. It may have been deleted manually.
                        If you feel it was removed in error, please contact support.<br />
                        To connect to the newly configured Meta infrastructure, click Reset IdP.
                    </FTBody>
                </FuseAlert>
            </Fragment>;
        }
        return <Fragment>
            <FuseConsoleField
                className={block('ConsoleField')}
                name="SAML Status"
                info="Enable/Disable SAML SSO support for this organization. Enabling will show
                      an additional SSO user administration menu item."
                infoPosition="right"
            >
                <FTBody>
                    {authConfStore.isConfEnabled
                        ? <span><b>Enabled</b> - SAML authentication is enabled.</span>
                        : <span> <b>Disabled</b> - SAML authentication is disabled.</span>}
                </FTBody>
            </FuseConsoleField>
            {authConfStore.isConfEnabled ? <FuseConsoleField
                className={block('ConsoleField')}
                name="Authentication Type"
                info="Configure a new IdP to use with Isolation for authentication and user
                      synchronization or, if you have a Proofpoint Meta account, select an existing
                      IdP configuration to use."
                infoPosition="right"
            >
                <FTBody>{this.getRenderAuthType(authConfStore)}</FTBody>
            </FuseConsoleField> : null}
            {authConfStore.isConfEnabled && authConfStore.isExternalIDP ? <div className={block('InnerSection')}>
                <FTHeading>Proofpoint Meta</FTHeading>
                <FuseConsoleField
                    className={block('ConsoleField')}
                    name="IdP Configuration"
                >
                    {authConfStore.metaExternalIdpName}
                </FuseConsoleField>
            </div> : null}

            {authConfStore.isConfEnabled && authConfStore.provisioningType && authConfStore.isOwnIDP ?
                <Fragment>
                    <div className={block('InnerSection')}>
                        <FTHeading>Users Provisioning and Group Synchronization</FTHeading>
                        <FuseConsoleField
                            className={block('ConsoleField')}
                            name="Provisioning Type"
                        >{authConfStore.ProvisioningTypeDisplayName}</FuseConsoleField>
                        {this.renderLDAP()}
                        {this.renderSCIM()}
                        {this.renderJIT(authConfStore)}
                    </div>
                    {this.renderIdentityProvider(authConfStore)}
                    {this.renderUrls(authConfStore)}
                </Fragment> : null}
        </Fragment>;
    }

    isLoading = () => {
        const { authenticationConfiguration, regOptions, console, policy } = this.props;

        return authenticationConfiguration.loadStatus.isLoading || (console.useRedesignedPolicy ?
            policy.browsingRoles.policyTable.listStatus.isLoading : regOptions.loadStatus.isLoading);
    };

    render() {
        const { authenticationConfiguration: authConfStore, console } = this.props;
        const readOnly = console.authority === ROLE_READ_ONLY.value;

        return <Page title="Product Settings - SAML/SSO Configuration" className={block()}>
            <ConsoleCard className={block('Section')}>
                {
                    !this.isLoading() && !readOnly && !authConfStore.isConfEnabled && this.state.useSSOLogin ?
                        <FuseAlert
                            type={'warning'}
                            className={block('SSODisabledWarning')}
                            title={'Warning -'}
                            subtitle={console.useRedesignedPolicy ?
                                <Fragment>
                                    Because SAML Status is disabled, the SSO operation will fail for both SAML/SSO
                                    browser registration and SAML/SSO administrator Console login.
                                </Fragment> : <Fragment>
                                    <a className={block('SpaceLink')}
                                        href={'/console/' + (console.useGeneralOptions()
                                            ? 'registration_options'
                                            : 'product_settings/general_options'
                                        )}
                                    >
                                        Registration Options
                                    </a>
                                    is currently set to SAML/SSO. Users will see an error while trying to register.
                                </Fragment>
                            }
                        /> : null
                }
                <div className={block('CardHeader')}>
                    <FTHeading>SAML Authentication</FTHeading>
                    {readOnly ? null : <Fragment>{authConfStore.hasSamlConnectionError ?
                        <FuseButton
                            type={'primary'}
                            color={'blue'}
                            loading={authConfStore.resetIdpConfigurationStatus.isLoading}
                            onClick={authConfStore.onResetIdpConfiguration}
                        >Reset IdP</FuseButton> :
                        <FuseButton
                            type={'primary'}
                            color={'blue'}
                            icon={'edit'}
                            onClick={authConfStore.openEditModal}
                            disabled={this.isLoading()}
                        >Edit</FuseButton>
                    }</Fragment>}
                </div>
                {this.isLoading()
                    ? <UDSpinner type={'fuse'} className={block('Loader')} />
                    : this.renderContent(authConfStore)}
            </ConsoleCard>
            <FuseConfirmationModal
                store={authConfStore.promptPopUp}
                onConfirm={authConfStore.editModal.close}
            />
            <EditConfigurationModal useSSOLogin={this.state.useSSOLogin} />
            <KeyCreateModal />
            <KeyDeleteModal />
            <ResetIDPModal />
        </Page>;
    }
}

export default inject('console', 'policy', 'regOptions', 'authenticationConfiguration', 'snack')(
    observer(AuthenticationConfigurationPage));
